/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import img1 from "../resources/images/activities/01.jpg";
import img2 from "../resources/images/activities/02.jpg";
import img3 from "../resources/images/activities/03.jpg";
import img4 from "../resources/images/activities/05.jpg";

import { Box, Typography, Grid } from "@mui/material";

import Image from "../components/image/Image";

export default function Activities(props) {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography
            variant="h4"
            className="bold"
            textAlign={"center"}
            letterSpacing={2}
            fontSize={25}
            mb={1}
          >
            도시락 나눔 / 도시락 배달
          </Typography>
          <Typography
            variant="subtitle1"
            fontSize={17}
            textAlign={"center"}
            lineHeight={2}
            mb={2}
          >
            "따뜻한 한 끼, 따뜻한 마음. 무료 도시락으로 취약한 독거 중장년층을
            돕고, 고독사를 예방합니다.”
          </Typography>

          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect src={img1} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img3} ratio={"16/9"} />
              </Box>
            </Grid>
          </Grid>
          <Box mt={5}>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2.5}
            >
              무료 급식을 통해 취약한 독거 중장년층의{" "}
              <strong>영양 부족을 해소</strong>하고, <strong>질병 회복</strong>
              을 돕습니다.
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2.5}
            >
              무기력과 우울감에 갇혀 있던 일상에서 벗어나, 도시락을 받으러
              나오는 작은 발걸음이 <strong>삶의 변화</strong>를 만듭니다.
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2.5}
            >
              따뜻한 관심 속에서 미소가 피어나고, 감사의 인사가 오가며{" "}
              <strong>새로운 희망</strong>이 시작됩니다.
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2.5}
            >
              {`<< 월. 수. 금 11:30 ~ 13:00  도시락 나눔  >>`}
            </Typography>
          </Box>
        </Box>
      </section>

      <section className="contents">
        <div>
          <Typography variant="h5" mb={2}>
            <strong className="blue">안부 확인(안부 앱)</strong>
          </Typography>

          <Grid container justifyContent={"space-between"}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "23vw" : "70vw"} mb={1}>
                <Image disabledEffect alt={""} src={img4} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
                width={nowMediaQuery !== "mobile" ? "40vw" : "80vw"}
                height={"100%"}
              >
                <Typography variant="subtitle1" fontSize={17} sx={{ my: 2 }}>
                  해피인은 2021년 10월부터 안부 앱*을 통해 방문자들의 출석, 건강
                  상태, 기분(심리), 대인 관계 등을 확인하고 있습니다.
                  <br />
                  <br /> 등록자가 미출석 할 경우 또는 건강 상태가 좋지 않은
                  것으로 확인된 경우 직접 연락하여 안부를 확인하며, 도시락을
                  직접 챙겨 배달하고 있습니다.
                  <br />
                  <br />
                  <br />* 2024월 4월 기준 안부 앱에 등록된 인원 : 약 650여명
                </Typography>
              </Box>
            </Grid>
          </Grid>
          {/* </Fade> */}
        </div>
      </section>
    </div>
  );
}
